<template>
    <rkm-area title="Procedimentos">
        <template slot="trailing">
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                title="Adicionar procedimento"
                small
            >
                <rkm-icon icon="plus" />
            </rkm-button>
        </template>

        <List :data="data" />
        <Modal :data="data" ref="Modal" />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: { List, Modal },
    props: {
        data: { type: Object, required: true },
    }
}
</script>